import { SupportingTableId } from '../reporting/supporting-table.model';

export enum ProcessSupportingTableUploadPayloadKeys {
  supportingTableId = 'supportingTableId',
  uploadActionId = 'uploadActionId',
}

export interface ProcessSupportingTableUploadPayload {
  [ProcessSupportingTableUploadPayloadKeys.supportingTableId]: SupportingTableId;
  [ProcessSupportingTableUploadPayloadKeys.uploadActionId]: string;
}
